export default __webpack_public_path__ + "static/media/React_ToDo_List.1767548b.webp";